import { Timeout } from '@crossbeam/types';

import { ref } from 'vue';

export default function ({ limit }: { limit: number }) {
  const searchValue = ref('');
  const delayedSearchValue = ref('');

  let timeout: Timeout | undefined;
  function search(newInput: string) {
    searchValue.value = newInput;
    clearTimeout(timeout);
    if (!newInput) {
      delayedSearchValue.value = '';
      return;
    }
    timeout = setTimeout(() => {
      delayedSearchValue.value = searchValue.value;
    }, limit);
  }

  return {
    searchValue,
    delayedSearchValue,
    search,
  };
}
